import { useContext } from "react";
import { AppContext } from "../App";
import teamImage from "../assets/home_furniture.jpg";
import operationsImage from "../assets/cleaning_living_rooms.jpg";

export default function HomeAboutSection() {
  const appContext = useContext(AppContext);

  return (
    <section className="section-shell">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-lg-6">
            <div className="image-stack-layout" data-aos="fade-up" data-aos-delay="100">
              <img src={teamImage} alt="MS Universal product and supply solutions" />
              <div className="image-stack-card" data-aos="fade-left" data-aos-delay="250">
                <strong>Mission</strong>
                <p>
                  To provide quality products and services in a timely and
                  affordable manner.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="editorial-panel">
              <h2 data-aos="fade-right" data-aos-delay="100">A refined distribution company with practical, on-the-ground capability.</h2>
              <p data-aos="fade-up" data-aos-delay="200">
                MS Universal Distributors supports clients with affordable,
                quality-driven supply solutions while also offering dependable
                cleaning services for homes and workspaces.
              </p>
              <p data-aos="fade-up" data-aos-delay="300">
                Our growth has been shaped by customer trust, consistent delivery,
                and a management team committed to professionalism in operations,
                procurement, and business administration.
              </p>

              <div className="row g-3 mt-2">
                <div className="col-sm-6">
                  <div className="mini-panel" data-aos="fade-right" data-aos-delay={400}>
                    <strong>Vision</strong>
                    <p>
                      To become a trusted solution for customers seeking affordable
                      and quality goods and services.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6" data-aos="fade-left" data-aos-delay={400}>
                  <div className="mini-panel mini-panel-image">
                    <img src={operationsImage} alt="MS Universal cleaning services" />
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary mt-4"
                onClick={() => appContext.navTo({ item: "about_us" })}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
